<script>
import compoment from '@/components/draggable/CustomComponents/Radio/DSimpleRadioPreview'
export default {
  name: 'DShowInLoopPreview',
  extends: compoment
}
</script>
